import { SuccessToastIcon } from "../constants/IconData";

const successToast = (toast, toastProps) => {

    return toast.showSuccess({
        ...toastProps,
        icon: <SuccessToastIcon />,
        duration: 2000
    });
}
export { successToast }